import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ToysIcon(props: IconProps) {
    return <Icon {...props} iconKey={"toys"}/>
}
